import React from "react"
import { Button, Dropdown, Typography } from "@mimber/ui-web"
import {
  MoreOutlined,
  CheckOutlined,
  CloseOutlined,
  DollarOutlined,
} from "@mimber/ui-web"
import { usePermissionedMenuItems } from "@/core/hooks/usePermissionedMenuItems"
import { useApproveRefundRequestModal } from "@/components/modals/ApproveRefundRequestModal"
import { useDenyRefundRequestModal } from "@/components/modals/DenyRefundRequestModal"
import { useProcessRefundModal } from "@/components/modals/ProcessRefundModal"
import { Resource, Action, EventRefundStatus } from "@mimber/schema"
import type { PermissionedMenuItem } from "@/core/hooks/usePermissionedMenuItems"
import type { EventRefundActionsDropdownProps } from "./EventRefundActionsDropdown.types"

const { Text } = Typography

export const EventRefundActionsDropdown: React.FunctionComponent<
  EventRefundActionsDropdownProps
> = ({
  eventUuid,
  refund,
  onActionComplete,
  size = "small",
  type = "text",
  iconOnly = true,
}) => {
  const { contextHolder: approveContextHolder, showApproveRefundRequestModal } =
    useApproveRefundRequestModal(eventUuid, onActionComplete)

  const { contextHolder: denyContextHolder, showDenyRefundRequestModal } =
    useDenyRefundRequestModal(eventUuid, onActionComplete)

  const { contextHolder: processContextHolder, showProcessRefundModal } =
    useProcessRefundModal(eventUuid, onActionComplete)

  const menuItems: PermissionedMenuItem[] = [
    ...(refund.status === EventRefundStatus.PENDING
      ? ([
          {
            key: "approve",
            label: "Approve",
            icon: <CheckOutlined />,
            resource: Resource.EVENT,
            action: Action.UPDATE,
            onClick: () => showApproveRefundRequestModal(refund),
          },
          {
            key: "deny",
            label: "Deny",
            icon: <CloseOutlined />,
            danger: true,
            resource: Resource.EVENT,
            action: Action.UPDATE,
            onClick: () => showDenyRefundRequestModal(refund),
          },
        ] as PermissionedMenuItem[])
      : []),
    ...(refund.status === EventRefundStatus.APPROVED
      ? ([
          {
            key: "process",
            label: "Process Refund",
            icon: <DollarOutlined />,
            danger: true,
            resource: Resource.EVENT,
            action: Action.UPDATE,
            onClick: () => showProcessRefundModal(refund),
          },
        ] as PermissionedMenuItem[])
      : []),
  ]

  const { items } = usePermissionedMenuItems({ items: menuItems })

  if (items.length === 0) {
    return <Text type="secondary">&mdash;</Text>
  }

  return (
    <>
      {approveContextHolder}
      {denyContextHolder}
      {processContextHolder}
      <Dropdown menu={{ items }} trigger={["click"]}>
        <Button
          type={type}
          icon={iconOnly ? <MoreOutlined /> : undefined}
          size={size}
        >
          {!iconOnly && "Actions"}
        </Button>
      </Dropdown>
    </>
  )
}
